<script setup lang="ts">
// Back arrow (Figma "Crumb"). Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="15.9314"
    height="13.6"
    viewBox="0 0 15.9314 13.6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M7.13137 12.8L1.13137 6.8L7.13137 0.8M1.13137 6.8H15.1314"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke="currentColor"
    />
  </svg>
</template>
